module.exports = __webpack_public_path__ + "static/media/rs.a12f03f5.svg";